export const config = {
  sectionTitle: 'Key facts on Cloud and DevOps\nat Modsen',
  items: [
    {
      id: 1,
      title: '>200',
      text: 'Over 200 completed projects',
    },
    {
      id: 2,
      title: '25+',
      text: 'Developing apps for 25+ business industry',
    },
    {
      id: 3,
      title: 'Senior-level',
      text: 'Senior-level engineers with relevant experience',
    },
    {
      id: 4,
      title: '1 week',
      text: 'Active Development launch within 1 week',
    },
  ],
}
